var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedCheckSync({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.555664,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.0714V3H9V10.0714H7ZM7 14V12.4286H9V14H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedCheckSync);
export default __webpack_public_path__ + "static/media/failed_check_sync.8c71190f80b85657f29ef07b3fba8f6a.svg";
export { ForwardRef as ReactComponent };